import React from "react";
import _ from "lodash";

import { ParentResourceItem } from "./components/ParentResourceItem";
import { LinkItem } from "./components/LinkItem";
import { ESearchLocations } from "../../../../types/SearchLocations";

export function ResultGroup({ group }) {
	const getItemByTypeGroup = {
		[ESearchLocations["explore-resources"].type]: (item) => (
			<ParentResourceItem key={item.id} data={item} />
		),
		[ESearchLocations["post"].type]: (item) => (
			<ParentResourceItem key={item.id} data={item} />
		),
		[ESearchLocations["tribe_events"].type]: (item) => (
			<ParentResourceItem key={item.id} data={item} />
		),
		[ESearchLocations["page"].type]: (item) => (
			<LinkItem key={item.id} data={item} />
		),
	};
	return (
		<div className="MuiGrid-root resultSectionContainer-23 MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12">
			<div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12">
				<h4 className="MuiTypography-root section-title MuiTypography-h4">
					{group.title || "Default Title"}
				</h4>
			</div>

			{_.map(group.resultItems, (item) => getItemByTypeGroup[group.type](item))}

			<div className="MuiBox-root MuiBox-root-103 Line-root-101 line-separator">
				<div className="Line-hr-102"></div>
			</div>
		</div>
	);
}
